import React from 'react'
import PropTypes from 'prop-types'
import { CallbackOnPipe } from '@morningtrain/react-helpers'

function OpenModalOnPipe (props) {
  const { modalRef } = props

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      if (!modalRef || !modalRef.current) {
        return reject('Tried to open modal, but the ref is empty')
      }

      Promise.resolve(modalRef.current.open())
        .then(() => {
          resolve(payload)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  return (
    <CallbackOnPipe callback={handleOnPipe} />
  )
}

OpenModalOnPipe.defaultProps = {
  modalRef: null
}

OpenModalOnPipe.propTypes = {
  modalRef: PropTypes.object.isRequired
}

export default OpenModalOnPipe
